module.exports = __webpack_public_path__ + "img/invite.ed4d35aa.svg";